var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viewer"},[(_vm.firstPageDownloaded)?_c('div',_vm._l((_vm.pages),function(page,i){return _c('PDFPageV2',{key:i,attrs:{"page":page}})}),1):_c('div',[_vm._v("\n    rosco...\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }